// ** React Imports
import {
    ChangeEvent,
    forwardRef,
    useState,
    useEffect,
    SyntheticEvent,
  } from "react";
  
  // ** MUI Imports
  import TableCell, { tableCellClasses } from "@mui/material/TableCell";
  import TableRow from "@mui/material/TableRow";
  import { styled } from "@mui/material/styles";
  import Wrapper from "../../../components/Wrapper";
  
  import useMediaQuery from "@mui/material/useMediaQuery";
  import { useTheme } from "@mui/material/styles";
  import Card from "@mui/material/Card";
  import Grid from "@mui/material/Grid";
  import Button from "@mui/material/Button";
  import Divider from "@mui/material/Divider";
  import MenuItem from "@mui/material/MenuItem";
  import TextField from "@mui/material/TextField";
  import InputLabel from "@mui/material/InputLabel";
  import Typography from "@mui/material/Typography";
  import CardContent from "@mui/material/CardContent";
  import FormControl from "@mui/material/FormControl";
  import Select  from "@mui/material/Select";
  import Checkbox from "@mui/material/Checkbox";
  // ** Third Party Imports
  import FormGroup from "@mui/material/FormGroup";
  import FormControlLabel from "@mui/material/FormControlLabel";
  import SearchIcon from "@mui/icons-material/Search";
  import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
  
  // ** Icons Imports
  
  // ** Third Party Styles Imports
  import "react-datepicker/dist/react-datepicker.css";
  import Box from "@mui/material/Box";
  import axios  from "axios";
  
  import { NavLink } from "react-router-dom";
  import Title from "../../../components/Title";
  import { Office } from "../../../models/office";
  import { Collect } from "../../../models/collect";
  import { reportLend } from "../../../models/reportlend";
  
  const CustomInput = forwardRef((props, ref) => {
    return (
      <TextField
        fullWidth
        {...props}
        inputRef={ref}
        label="Date"
        autoComplete="off"
      />
    );
  });
  
  const DiasAtraso = () => {
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
      [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#9d9d9d",
        color: theme.palette.common.white,
      },
      [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
      },
    }));
  
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
      "&:last-child td, &:last-child th": {
        border: 0,
      },
    }));
  
    // ** States
    const [date, setDate] = useState<Date | null | undefined>(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [office_id, setOffice_id] = useState("");
    const [collect_id, setCollect_id] = useState("");
    const [collectsOffice, setCollectsOffice] = useState([]);
    const [lends, setLends] = useState([]);
    const [marcado, setMarcado] = useState("");
    const [start_date, setStart_date] = useState("");
    const [end_date, setEnd_date] = useState("");
    const [fechas, setFechas] = useState([]);
  
    const submit = async (event: SyntheticEvent) => {
      event.preventDefault(); // Evita el envío del formulario por defecto
  
      const formData = {
        end_date,
        start_date,
        collect_id: selectedCollects,
      };
  
      const url = "/report/lendlate";
  
      try {
        const response = await axios.post(url, formData);
        setFechas(response.data.data);
      } catch (error: any) {
        console.error("Error:", error);
      }
    };
  
    const [selectedCollects, setSelectedCollects] = useState<string[]>([]);
  
    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSelectedCollects((prevSelectedCollects) => {
        if (prevSelectedCollects.includes(value)) {
          return prevSelectedCollects.filter((id) => id !== value);
        } else {
          setMarcado(value);
          return [...prevSelectedCollects, value];
        }
      });
    };
  
    useEffect(() => {
      if (office_id) {
        (async () => {
          try {
            const { data } = await axios.get(`collectsoffice/${office_id}`);
            setCollectsOffice(data);
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        })();
      }
    }, [office_id]);
  
    useEffect(() => {
      if (marcado) {
        (async () => {
          try {
            const { data } = await axios.get(`lendcollect/${marcado}`);
            setLends(data.data);
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        })();
      }
    }, [marcado]);
  
    const [offices, setOffices] = useState([]);
    useEffect(() => {
      (async () => {
        const { data } = await axios.get("offices");
        setOffices(data.data);
      })();
    }, []);
    const columns: GridColDef[] = [
      { field: 'id', headerName: 'No. Crédito', flex: 1 },
      { field: 'idnumber', headerName: 'ID Cliente', flex: 1 },
      { field: 'fullname', headerName: 'Cliente', flex: 1 },
      { field: 'lend_value', headerName: 'Valor préstamo', flex: 1 },
      { field: 'value', headerName: 'Abonos', flex: 1 },
      { field: 'pay_date', headerName: 'Fecha', flex: 1 },
      { field: 'balance', headerName: 'Saldo', flex: 1 },
      { field: 'days_late', headerName: 'Días Atraso', flex: 1 },
      { field: 'collect', headerName: 'Cobro', flex: 1 },
  ];
  const rows =fechas.map((reportLend: reportLend) => ({
      ...reportLend,
      id: reportLend.id,
      idnumber: reportLend.lend.client.idnumber,
      fullname: reportLend.lend.client.fullname,
      lend_value: reportLend.lend.value,
      value: reportLend.value,
      pay_date: reportLend.pay_date,
      balance: reportLend.balance,
      days_late: reportLend.days_late,
      collect: reportLend.lend.collect.name,
  }));

  
    return (
      <div style={{ height: "95%", width: "95%" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Title>Cargar Archivos Clientes</Title>
          {/* <Button
            variant="contained"
            onClick={submit}
            startIcon={isMobile ? null : <SearchIcon />}
          >
            {isMobile ? <SearchIcon /> : "Buscar"}
          </Button> */}
        </Box>
        <Card>
          <Divider sx={{ margin: 0 }} />
          <form onSubmit={(e) => e.preventDefault()}>


            <CardContent>
               <Grid container spacing={2}>
                {/* <Grid item xs={12}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    Informe Días Atraso
                  </Typography>
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="form-layouts-separator-select-label">
                      Seleccionar Oficina
                    </InputLabel>
                    {offices && offices.length > 0 ? (
                      <Select
                        label="Seleccionar Oficina"
                        value={office_id}
                        id="form-layouts-separator-select"
                        labelId="form-layouts-separator-select-label"
                        onChange={(event) => setOffice_id(event.target.value)}
                        required
                      >
                        {offices.map((office: Office) => {
                          return (
                            <MenuItem key={office.id} value={office.id}>
                              {office.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="form-layouts-separator-select-label">Seleccionar Cobro</InputLabel>
                    {collectsOffice && collectsOffice.length > 0 ? (
                      <FormControl>
                        <FormGroup>
                          <Grid container>
                            {collectsOffice.map((collect: Collect) => (
                              <FormControlLabel
                                key={collect.id}
                                control={
                                  <Checkbox
                                    checked={selectedCollects.includes(
                                      collect.id.toString()
                                    )}
                                    onChange={handleCheckboxChange}
                                    value={collect.id.toString()}
                                  />
                                }
                                label={collect.name}
                              />
                            ))}
                          </Grid>
                        </FormGroup>
                      </FormControl>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ marginBottom: 0 }} />
                </Grid>
              </Grid>
            </CardContent>

          </form>
        </Card>
      </div>
    );
  };
  
  export default DiasAtraso;
  